module.exports = __webpack_public_path__ + "img/food_play.ca22b209.png";